module.exports = __webpack_public_path__ + "static/media/empf styleguide.fc01da5f.png";